/* eslint-disable import/prefer-default-export */
// kind: phone, email, code, unit_max_2, unit_max_3, block_number
export const validateInput = (kind, value, dynamicContent) => {
  let err = '';
  const regexPhone = new RegExp(/^(6|8|9)\d{7}$/);
  const regexNRIC = /^[a-zA-Z0-9]+$/igm;
  const regexPassword = /^(?:(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).*)$/;
  switch (kind) {
    case 'phone':
      if ((!regexPhone.test(value) || value.length !== 8) || (!regexPhone.test(value) && value.length > 1)) {
        err = 'Please enter a valid mobile number';
      }
      if (value.length === 0) {
        err = '';
      }
      return err;
    case 'phone-home':
      if ((!regexPhone.test(value) || value.length !== 8) || (!regexPhone.test(value) && value.length > 1)) {
        err = 'Please enter a valid home number';
      }
      if (value.length === 0) {
        err = '';
      }
      return err;
    case 'phone-office':
      if ((!regexPhone.test(value) || value.length !== 8) || (!regexPhone.test(value) && value.length > 1)) {
        err = 'Please enter a valid office number';
      }
      if (value.length === 0) {
        err = '';
      }
      return err;
    case 'phone_main':
      if (!regexPhone.test(value) || value.length !== 8) {
        err = 'Please enter a valid mobile number';
      }
      if (value.length === 0) {
        err = '';
      }
      return err;
    case 'email':
      const regexEmail = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g;
      if (!regexEmail.test(value)) {
        err = 'Please enter a valid email address';
      }
      if (value.length === 0) {
        err = '';
      }
      return err;
    case 'post_code_singapore':
      if (value.length === 0 || value.length < 6) {
        err = 'Please enter a valid postal code';
      }
      return err;
    case 'post_code':
      if (value.length === 0) {
        err = 'Please enter a valid postal code';
      }
      return err;
    case 'block_number':
      if (value.length === 0) {
        err = '';
      }
      if (value.length > 6) {
        err = 'Please use maximum of 6 characters';
      }
      return err;
    case 'nric':
      if (!regexNRIC.test(value) || value.length !== 4) {
        // err = 'Please enter a valid identification number';
        err = dynamicContent && dynamicContent.verification_page.ERROR_MSG.MSG1;
      }
      if (value.length === 0) {
        err = '';
      }
      return err;
    case 'userID':
      if (value.length < 6 || value.length > 15 || value.includes(' ') || !isNaN(value)) {
        // err = 'Please use 6 to 15 characters, including at least one letter';
        err = dynamicContent && dynamicContent.setup_ospl_page.ERROR_MSG.MSG1;
      }
      // eslint-disable-next-line no-restricted-globals
      // if (!isNaN(value)) {
      //   // err = 'Your user ID cannot be all numbers';
      //   err = dynamicContent && dynamicContent.setup_ospl_page.ERROR_MSG.MSG2;
      // }
      if (value.length === 0) {
        err = '';
      }
      return err;
    case 'accessCode':
      // eslint-disable-next-line vars-on-top
      if (value.length < 6 || value.length > 14) {
        // err = 'Please use 6 to 14 characters, including at least one letter';
        err = dynamicContent && dynamicContent.setup_inb_page.ERROR_MSG.MSG1;
      }
      // eslint-disable-next-line no-restricted-globals
      if ((value.length === 7 || value.length === 8) && !isNaN(value)) {
        // err = 'Your access code cannot be only a 7-digit or 8-digit number';
        err = dynamicContent && dynamicContent.setup_inb_page.ERROR_MSG.MSG2;
      }
      if (value.length === 0) {
        err = '';
      }
      return err;
    case 'year':
      if (value.length < 4) {
        // err = 'Please enter a valid year';
        err = dynamicContent && dynamicContent.verification_page.ERROR_MSG.MSG2;
      }
      if (value.length === 0) {
        err = '';
      }
      return err;
    case 'day':
      if (Number(value) < 1 || Number(value) > 31) {
        // err = 'Please enter a valid date';
        err = dynamicContent && dynamicContent.verification_page.ERROR_MSG.MSG4;
      }
      if (value.length === 0) {
        err = '';
      }
      return err;
    case 'month':
      if (Number(value) < 1 || Number(value) > 12) {
        // err = 'Please enter a valid month';
        err = dynamicContent && dynamicContent.verification_page.ERROR_MSG.MSG3;
      }
      if (value.length === 0) {
        err = '';
      }
      return err;
    case 'password':
      if (!regexPassword.test(value) || value.length < 8 || value.length > 15) {
        // err = 'Please include a number (0-9), uppercase letter (A-Z) and lowercase letter (a-z)';
        err = dynamicContent && dynamicContent.setup_ospl_page.ERROR_MSG.MSG3;
      }
      if (value.length === 0) {
        err = '';
      }
      return err;
    case 'refCode':
      if (!/^[A-Za-z0-9]*$/.test(value) || value.length !== 8) {
        err = 'Must be 8 characters, including a number (0-9), an uppercase (A-Z), a lowercase (a-z). Do not use special characters (eg. #@-).';
      }
      return err;
    default:
      return err;
  }
};
